// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>An unexpected error occurred and we were unable to process your payment. We apologize for the inconvenience.</h1>
        </div>
        <div class="hoa-dialog__main">
            <p>
                Please contact
                <a (click)="tools.openUrl('https://www.firstcitizens.com/hosted/community-association-banking-customer-support')">
                    First Citizens Bank</a>
                should you continue to receive this error.
            </p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--blue Button--minWidth130" (click)="closeThisDialog(0)">OK</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;